<template>
  <div>
    <app-heading
      :text="'Order Qualification'"
      :heading="'main'"
    ></app-heading>
    <v-divider class="mt-6 mb-4"></v-divider>
    <order-qualification-form
      ref="qualificationFormNbn"
      :isNewOrder="false"
      @showOrderResultSection="showOrderResultSection"
      @toggleInput="toggleInput"
      @orderTypeChanged="orderTypeChanged"
    ></order-qualification-form>

    <order-qualification-result
      ref="qualificationResultNbn"
      class="mt-5"
    ></order-qualification-result>
  </div>
</template>

<script>
export default {
  name: "OrderQualification",
  data: () => ({
    enable: false,
    showResult: false,
    showLocIdInput: false,
  }),
  methods: {
    showOrderResultSection(details) {
      let vm = this;
      vm.$refs.qualificationResultNbn.showOrderResult = true;
      vm.$refs.qualificationResultNbn.result = details;
    },
    toggleInput(state) {
      let vm = this;
      vm.showResult = state;
      vm.showLocIdInput = state;
    },
    orderTypeChanged() {
      let vm = this;
      vm.showResult = false;
      vm.$refs.qualificationResultNbn.showOrderResult = false;
      vm.$refs.qualificationResultNbn.result = {};
    },
  }
}
</script>

<style scoped>

</style>
